import { TFunction } from 'i18next'

export const getTableActions = (t: TFunction) => {
  return {
    permissions: (callback: () => void) => ({
      key: 'permissions',
      label: t('button.permissions'),
      onClick: callback
    }),

    delete: (callback: () => void) => ({
      key: 'delete',
      label: t('button.delete'),
      onClick: callback
    }),

    reInvite: (callback: () => void) => ({
      key: 're-invite',
      label: t('re_invite'),
      onClick: callback
    }),

    edit: (callback: () => void) => ({
      key: 'edit',
      label: t('button.edit'),
      onClick: callback
    })
  }
}
